import React from "react";
import { Box, List, ListItem, Text, useBreakpoint } from "@chakra-ui/react";
import breakpoints from "../../theme/foundations/breakpoints";
const CompanyBox = ({ companyTitle, companyDesc }) => {
  const breakpoint = useBreakpoint({ ssr: false });
  const breakpointSize = breakpoints[breakpoint];
  const isSmallScreen = breakpointSize < "64em";
  return (
    <Box
      bg="rgba(30,41,59,0.7)"
      color="rgb(94,234,212)"
      borderRadius="0.5rem"
      p={4}
      w={isSmallScreen ? "100%" : "40%"}
      mt={isSmallScreen ? 6 : 0}
      mb={{ base: "2rem", smm: isSmallScreen ? "0rem" : "2rem" }}
    >
      <Text
        fontSize="1.25rem"
        lineHeight="1.6"
        fontWeight="500"
        color="rgb(226,232,240)"
      >
        {companyTitle}
      </Text>
      <Box display="flex" flexDir="column" gap="1rem">
      <List styleType="disc">
        {companyDesc.map((para) => {
          return (
            <ListItem
              key={para}
              fontWeight="400"
              lineHeight="1.5"
              color="#D6D6D6"
              textAlign={{ base: "justify", md: "left" }}
              marginBottom="0.5rem"
            >
               {para}
            </ListItem>
          );
        })}
        </List>
      </Box>
    </Box>
  );
};

export default CompanyBox;
